import React, { useState } from 'react'
import { H2, FlexCenter, Flex, ExpandMoreIcon } from '../../lib/components'

interface faqAccordionProps {
  question: string
  answer: string
  isActive: boolean
  setIsActive: (val: boolean) => void
}

const faqs = [
  {
    question: 'Why invest in Private Markets',
    answer:
      'Private markets offer unique investment opportunities with potential for higher returns, portfolio diversification, and access to innovative companies and assets not available in public markets.',
  },
  {
    question: 'Who can invest through Credibila?',
    answer:
      'To invest with Credibila, clients need to qualify as accredited clients. This means completing the KYC registration process. Once this is done, our team will inform clients about their eligibility. Our KYC process is mostly automated, aiming to finish within 4 business hours after application submission. If additional information is needed, it might take a bit longer, but we will keep you informed every step of the way.',
  },
  {
    question: 'How much can I Invest?',
    answer:
      "Each accredited Client, after the completion of the KYC process, will be allotted an Investment Limit which will be dependent on the accredited Client's net worth or source of funds.",
  },
  {
    question: 'Where can I find more financial information about the opportunity?',
    answer:
      "For each Opportunity, the Credibila Team will attach a complete profile along with the link to the Company's website.",
  },
  {
    question: 'What will be the return on my investment be?',
    answer: 'Returns vary per investment opportunity.',
  },
  {
    question: 'Can I cancel my investment at any time?',
    answer:
      'You can cancel an investment request anytime prior to transferring funds. After your investment is complete, you may redeem from the holding (subject to each Opportunity’s terms). To move cash from your wallet to your bank account, use Withdraw. Please check the Opportunity page for the terms and conditions that may apply for each Opportunity.',
  },
  {
    question: 'What documents do I have to provide to complete my KYC?',
    answer:
      'FOR AN INDIVIDUAL, we accept the following documents: ID card/ current valid Passport/ Visa, Proof of address within 3 months of the issue (utility bill or bank/credit statement, or equivalent document), Original Bank reference Letter issued within 3 months, Duly signed and dated CV showing all qualifications and employment history, Professional Reference, Salary confirmation if any, Police clearance if applicable, Source of Funds/ Source of Wealth, PEP status confirmation, Tax status confirmation. Please note that the above is not an exhaustive list and further documents may be requested additionally.',
  },
  {
    question: 'Is my confidential information safe with Credibila?',
    answer:
      "Maintaining the integrity and security of our Client's data is a priority for Credibila. We follow industry standards and address security in three major components: physical security, corporate IT security and production security. Learn More by reviewing our Privacy Policy.",
  },
  {
    question:
      'How long should I expect the verification process to be after I submit the requested documents?',
    answer: 'You can expect the verification process to be completed within 4 business hours.',
  },
  {
    question: 'Why does Credibila need to verify my identity?',
    answer:
      'This requirement is in line with the provisions as set out by the Financial Services Commission ("FCS"), Mauritius in its FSC AML/CFT Handbook and other laws and regulations prevailing in Mauritius which the Company should adhere to.',
  },
  {
    question: 'Why is my Investment Account pending?',
    answer:
      'If a red error shows in your Investment Account, please see if you can update your information within your account. If no error shows, or your account requires manual review, please reach out to support@credibila.com.',
  },
  {
    question: 'How do I deactivate my account?',
    answer: 'To deactivate your account, please contact your relationship manager.',
  },
  {
    question: 'Where can I find the wire details?',
    answer:
      'Once you have picked the opportunity you would like to invest in, you will subscribe to the offer and submit your payment directly to the Bank Account of Credibila. The Bank Account details of Credibila will be shown in a subsequent page after the subscription to the offer. You can also find the instructions to complete your wire transfer by logging into your Credibila account, clicking your name in the top right corner and selecting "View Current" under "My Investments". You can now simply select the "View Investment" button next to the appropriate investment, and you will be able to view all of the required wire instructions.',
  },
  {
    question: 'When and how will I get confirmation on my investment?',
    answer:
      'Once Credibila receives your funds, you will receive a confirmation email from Credibila with the details about your investment, along with a copy of the terms outlining your investment details.',
  },
]

const Accordion = ({ question, answer, isActive, setIsActive }: faqAccordionProps) => {
  return (
    <div className='accordion'>
      <div className='accordion-item'>
        <div className='learn-more-accordion-title' onClick={() => setIsActive(!isActive)}>
          <div>{question}</div>
          <div className='learn-more-accordion-icon'>
            {isActive ? <ExpandMoreIcon classes={['learn-more-collapse']} /> : <ExpandMoreIcon />}
          </div>
        </div>
        {isActive && <div className='accordion-content'>{answer}</div>}
      </div>
    </div>
  )
}

const FirstTimeInvestorPresenter = () => {
  const [isActive, setIsActive] = useState(false)
  const [activeIndex, setIsActiveIndex] = useState<number | null>(null)

  return (
    <>
      <FlexCenter classes={['mb-40 mt-19']}>
        <H2 text='First Time Client' classes={['mb-24']} />
      </FlexCenter>
      <Flex variant='column' classes={['faq-accordion', 'mt-36']}>
        {faqs.map((faq, index) => (
          <Accordion
            key={index}
            question={faq.question}
            answer={faq.answer}
            isActive={activeIndex === index ? isActive : false}
            setIsActive={(val: boolean) => {
              setIsActiveIndex(index)
              return setIsActive(val)
            }}
          />
        ))}
      </Flex>
    </>
  )
}

export { FirstTimeInvestorPresenter }
